/* unplugin-vue-components disabled */import { render } from "./Dashboard.vue?vue&type=template&id=4ff0d010&scoped=true&ts=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=4ff0d010&lang=scss&scoped=true"
import "./Dashboard.vue?vue&type=style&index=1&id=4ff0d010&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff0d010"]])

export default __exports__